import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getDateObject } from './dateutils';

// Can accept date objects or ISO format dates as value.
const DatePickerInput = (props) => {
  const {
    id,
    onChange,
    value,
    label,
    views,
    format,
    required,
    error,
    closeOnSelect,
    minDate,
    maxDate,
    disabled,
    hideCalendar = false,
    variant = 'standard',
    unstyled = false,
  } = props;
  let valueObj = getDateObject(value);
  let minDateObj = getDateObject(minDate);
  let maxDateObj = getDateObject(maxDate);
  const styles = unstyled
    ? { width: '100%' }
    : {
        padding: '4px',
        marginLeft: '19px',
        marginRight: '6px',
        marginTop: '7px',
      };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div data-cy={id + '-div'}>
        <DatePicker
          label={label}
          value={valueObj}
          views={views}
          minDate={minDateObj}
          maxDate={maxDateObj}
          format={format}
          onChange={(newValue) => {
            onChange(newValue);
          }}
          slotProps={{
            textField: {
              id: id,
              required: required,
              error: error,
              variant: variant,
              style: { ...styles },
              inputProps: { 'data-cy': id },
              InputProps: hideCalendar && { endAdornment: <></> },
            },
            inputAdornment: { position: 'end' },
          }}
          closeOnSelect={closeOnSelect || true}
          disabled={disabled || false}
        />
      </div>
    </LocalizationProvider>
  );
};

DatePickerInput.propTypes = {
  id: PropTypes.any,
  onChange: PropTypes.func,
  views: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  format: PropTypes.any,
  required: PropTypes.bool,
  error: PropTypes.any,
  label: PropTypes.any,
  closeOnSelect: PropTypes.bool,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  unstyled: PropTypes.bool,
  hideCalendar: PropTypes.bool,
};

export default DatePickerInput;
